// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='MetadataTimelineHeader'] {\n  font-size: 12px;\n  color: var(--primary-font-color);\n  font-weight: 400;\n  height: 40px;\n  top: 6px;\n  position: absolute;\n  box-shadow: inset 0 -1px 0 0 var(--border-color-1);\n  background: var(--dropdown-bg-selected);\n}\n  [name='MetadataTimelineHeader'] text {\n    width: 30px;\n    fill: var(--secondary-font-color);\n  }\n", ""]);
// Exports
module.exports = exports;
